import React, { useState, useEffect } from 'react';
import styles from './MeasureToolContainer.module.scss';

export const TextStyleTool = ({ selectStyle, styleSlected, allStyleSectionData, changeFontSize }) => {
  return (
    <div className={styles.textMod}>
      <span className={styles.textHead}>Aa -</span> 
        <div style={{ width: '60px', height: '100%'}}>
          <input
            type="number"
            value={allStyleSectionData?.textSize}
            onInput={changeFontSize}
            className={styles.fontSizeClass}
            min={0}
            max={60}
          />
        </div>
      <div
        className={`${styles.textModSubClass} ${
          styleSlected === 'bold' ? styles.textModSelected : ''
        }`}
        onClick={() => selectStyle('bold')}>
        <div className={`${styles.textColorDiv} ${styles.bold}`}>
          B
        </div>
      </div>
      <div
        className={`${styles.textModSubClass} ${
          styleSlected === 'italic' ? styles.textModSelected : ''
        }`}
        onClick={() => selectStyle('italic')}>
        <div className={`${styles.textColorDiv} ${styles.italic}`}>
          I
        </div>
      </div>
      <div
        className={`${styles.textModSubClass} ${
          styleSlected === 'underline' ? styles.textModSelected : ''
        }`}
        onClick={() => selectStyle('underline')}>
        <div className={`${styles.textColorDiv} ${styles.underline}`}>
          U
        </div>
      </div>
    </div>
  );
};
